var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages_but"},[(false)?_c('button',{staticClass:"hidden-messages-toggle"},[_c('span')]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages-wrapper"},[_c('div',{staticClass:"hidden-messages-list"})])
}]

export { render, staticRenderFns }